import { toastService } from "src/libraries/toast";
import { subscriptionsService } from "../entity/subscriptions/SubscriptionsService";

export const updateSubscriptionUseCase = async (payload: {id: number, apple_product_id: string | null, google_product_id: string | null}) => {
    try {
        const response = await subscriptionsService.update(payload);
        if (response?.isError) {
            toastService.onError('Some error');
        } else {
            return response.data;
        }
    } catch (error) {
        console.warn('updateSubscriptionUseCase: ', error);
    };
};
